<template>
  <li class="webinar">
    <v-radio
      :label="webinarDuration"
      :value="webinar.webinar_id"
      color="#5FD068"
      active-class="active"
      :class="{ active: isSelected }"
    ></v-radio>
  </li>
</template>

<script>
import moment from "moment";

export default {
  name: "SingleWebinar",
  props: {
    webinar: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$emit("choose-selected-webinar", this.selectedWebinar);
  },
  computed: {
    /**
     * Format date of webinar to set it in label
     */
    webinarDuration() {
      return `${moment(this.webinar.start_time, "HH:mm:ss").format(
        "hh:mm"
      )} - ${moment(this.webinar.end_time, "HH:mm:ss").format("hh:mm A")}`;
    },
    /**
     * Get selected webinar
     */
    selectedWebinar() {
      return this.$store.getters.GET_WEBINAR_ID;
    },
    /**
     * Get selected webinar to style it
     */
    isSelected() {
      return this.selectedWebinar === this.webinar.webinar_id;
    },
  },
};
</script>

<style lang="scss" scoped>
.webinar {
  background: $white;
  outline: 1px solid $description;
  border-radius: 8px;
  font-family: $font-family;
  font-style: normal;
  font-weight: 500;
  font-size: 1.125rem;
  line-height: 1.5625rem;
  color: #061c3d;
  max-width: 557px;

  &:has(.active) {
    background: #e7f5e8;
    outline: 2px solid $green;
  }
}
::v-deep .v-radio {
  padding: 16px 18px;
  .v-input--selection-controls__input {
    margin-inline-end: 18px;
  }
  .v-label {
    line-height: 1.5625rem;
  }
}
</style>
